<template>
  <b-container class="container-max-width">
    <b-row v-if="label" align-h="center">
      <label class="d-block">{{ label }}</label>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-form-group
          class="no-margin-bottom"
          label="From"
          :label-for="fromId"
          label-align="center"
        >
          <b-card>
            <b-row align-h="start">
              <b-col cols="8">
                <Datepicker
                  @selected="$emit('change')"
                  :id="fromId"
                  :format="format"
                  v-model="localValue.from"
                  v-bind="$attrs"
                />
              </b-col>
              <b-col>
                <i class="flaticon2-calendar-9 kt-font-brand"></i>
              </b-col>
            </b-row>
          </b-card>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group
          class="no-margin-bottom"
          label="To"
          :label-for="toId"
          label-align="center"
        >
          <b-card>
            <b-row align-h="start">
              <b-col cols="8">
                <Datepicker
                  @selected="$emit('change')"
                  :id="toId"
                  :format="format"
                  v-model="localValue.to"
                  v-bind="$attrs"
                />
              </b-col>
              <b-col>
                <i class="flaticon2-calendar-9 kt-font-brand"></i>
              </b-col>
            </b-row>
          </b-card>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  props: {
    value: {
      from: {
        type: Date,
        default() {
          return new Date();
        }
      },
      to: {
        type: Date,
        default() {
          return new Date();
        }
      },
      default() {
        return {
          from: new Date(),
          to: new Date()
        };
      }
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    fieldName: {
      type: String,
      required: false,
      default: null
    },
    format: {
      type: String,
      default: "yyyy-MM-dd",
      required: false
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    fromId() {
      return `${this.fieldName}-from`;
    },
    toId() {
      return `${this.fieldName}-to`;
    }
  },
  components: {
    Datepicker
  }
};
</script>

<style lang="scss" scoped>
.no-margin-bottom {
  margin-bottom: 0rem;
}

.container-max-width {
  max-width: 370px;
}
</style>
